import { ɵɵdirectiveInject, ɵɵdefineDirective, ɵɵclassProp, ɵsetClassMetadata, Directive, Self, HostBinding, ɵɵdefinePipe, Pipe, ɵɵelementContainerStart, ɵɵelement, ɵɵpipe, ɵɵelementContainerEnd, ɵɵnextContext, ɵɵadvance, ɵɵproperty, ɵɵpipeBind1, ɵɵsanitizeHtml, ɵɵdefineComponent, ɵɵtemplate, Component, Optional, Input, EventEmitter, ɵɵdefineInjectable, Injectable, ɵɵdefineNgModule, ɵɵdefineInjector, ErrorHandler, NgModule, ɵɵsetNgModuleScope, ɵɵinject, ɵɵInheritDefinitionFeature, ɵɵgetInheritedFactory, ElementRef, ɵɵlistener, HostListener, Renderer2, ɵɵProvidersFeature } from '@angular/core';
import { NgControl, Validators, FormGroup, FormGroupDirective, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment_ from 'moment';
import { trigger, transition, style, animate } from '@angular/animations';
import { NgForOf, CurrencyPipe, DecimalPipe, CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import * as deepMerge_ from 'deepmerge';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { createTextMaskInputElement } from 'text-mask-core';

var Rule;
(function (Rule) {
    Rule["Dirty"] = "dirty";
    Rule["Touched"] = "touched";
})(Rule || (Rule = {}));
class ValidationConfiguration {
    constructor() {
        this.defaultRules = [Rule.Touched, Rule.Dirty];
    }
}

// Disabled tslint to apply directive to all form controls
// without having to provide `ef-` prefix for selector.
// tslint:disable-next-line:directive-selector
class ValidationInputClassDirective {
    constructor(control, configuration) {
        this.control = control;
        this.configuration = configuration;
        if (!configuration) {
            configuration = {
                defaultRules: [Rule.Touched, Rule.Dirty],
            };
        }
    }
    get invalid() {
        return (this.control.invalid &&
            this.configuration.defaultRules.every((rule) => this.control[rule]));
    }
}
ValidationInputClassDirective.ɵfac = function ValidationInputClassDirective_Factory(t) { return new (t || ValidationInputClassDirective)(ɵɵdirectiveInject(NgControl, 2), ɵɵdirectiveInject(ValidationConfiguration)); };
ValidationInputClassDirective.ɵdir = ɵɵdefineDirective({ type: ValidationInputClassDirective, selectors: [["", "formControlName", ""]], hostVars: 2, hostBindings: function ValidationInputClassDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵɵclassProp("invalid", ctx.invalid);
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ValidationInputClassDirective, [{
        type: Directive,
        args: [{ selector: '[formControlName]' }]
    }], function () { return [{ type: NgControl, decorators: [{
                type: Self
            }] }, { type: ValidationConfiguration }]; }, { invalid: [{
            type: HostBinding,
            args: ['class.invalid']
        }] }); })();

class ValidationError {
    constructor(name, rules, text) {
        this.name = name;
        this.rules = rules;
        this.text = text;
    }
}
class ValidationMessagesError {
    constructor(validatorName, rules, text) {
        this[validatorName] = new ValidationError(validatorName, rules, text);
    }
}

const moment = moment_;
const dateRangeValidatorName = 'dateRange';
function dateRangeValidator(minRange, maxRange, text = 'Invalid range', rules) {
    return function (control) {
        const dateFormat = 'MM/DD/YYYY';
        if (moment(control.value, dateFormat, true).isValid()) {
            const date = moment(control.value, dateFormat);
            const min = moment(minRange, dateFormat).startOf('day');
            const max = moment(maxRange, dateFormat).endOf('day');
            const isValidDateAndWithinRange = date.isSameOrAfter(min) && date.isSameOrBefore(max);
            if (isValidDateAndWithinRange) {
                return null;
            }
        }
        return new ValidationMessagesError(dateRangeValidatorName, rules, text);
    };
}

const moment$1 = moment_;
const dateValidatorName = 'date';
function dateValidator(text = 'Invalid Date.', rules) {
    return function (control) {
        return moment$1(control.value, 'MM/DD/YYYY', true).isValid()
            ? null
            : new ValidationMessagesError(dateValidatorName, rules, text);
    };
}

const emailValidatorName = 'email';
// tslint:disable-next-line:max-line-length
const emailRegex = /^((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?/;
function emailValidator(text = 'Please enter a valid email address.', rules) {
    return function (control) {
        if (emailRegex.test(control.value)) {
            return null;
        }
        else {
            return new ValidationMessagesError(emailValidatorName, rules, text);
        }
    };
}

const fixedLengthValidatorName = 'fixedLength';
function fixedLengthValidator(fixedLength, text = 'Invalid Entry', rules) {
    return function (control) {
        const matchesLength = (typeof control.value === 'number' ||
            typeof control.value === 'string') &&
            control.value.toString().length === fixedLength;
        if (matchesLength) {
            return null;
        }
        else {
            return new ValidationMessagesError(fixedLengthValidatorName, rules, text);
        }
    };
}

const inputMatchValidatorName = 'inputMatch';
function inputMatchValidator(comparisonControlNameFromRootControl, text = `Inputs do not match`, rules) {
    return function (control) {
        const controlTreeStructureNotInitialized = control === control.root;
        if (controlTreeStructureNotInitialized) {
            return null;
        }
        const comparisonControl = control.root.get(comparisonControlNameFromRootControl);
        if (!comparisonControl) {
            throw new Error(`Input Match Validator -- no control found for control path ${comparisonControlNameFromRootControl}`);
        }
        if (comparisonControl.value !== control.value) {
            return new ValidationMessagesError(inputMatchValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}

const inputNotMatchValidatorName = 'inputNotMatch';
function inputNotMatchValidator(comparisonControlNameFromRootControl, text = `Inputs match`, rules) {
    return function (control) {
        const controlTreeStructureNotInitialized = control === control.root;
        if (controlTreeStructureNotInitialized) {
            return null;
        }
        const comparisonControl = control.root.get(comparisonControlNameFromRootControl);
        if (!comparisonControl) {
            throw new Error(`Input Not Match Validator -- no control found for control path ${comparisonControlNameFromRootControl}`);
        }
        if (comparisonControl.value === control.value) {
            return new ValidationMessagesError(inputNotMatchValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}

const inputsMatchValidatorName = 'inputsMatch';
function inputsMatchValidator(controlOnePath, controlTwoPath, text = `Inputs do not match`, rules) {
    return function (control) {
        const controlOne = control.get(controlOnePath);
        if (!controlOne) {
            throw new Error(`Inputs Match Validator -- no control found for control path ${controlOnePath}`);
        }
        const controlTwo = control.get(controlTwoPath);
        if (!controlTwo) {
            throw new Error(`Inputs Match Validator -- no control found for control path ${controlTwoPath}`);
        }
        if (controlOne.invalid || controlTwo.invalid) {
            return null;
        }
        if (controlOne.value !== controlTwo.value) {
            return new ValidationMessagesError(inputsMatchValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}

const itinValidatorName = 'itin';
// ITIN definition found in docs/glossary.md
function itinValidator(text = 'Invalid Entry. Individual Taxpayer Identification Numbers are not accepted.', rules) {
    return function (control) {
        const isSsn = control.value && control.value.match(/^\d{3}-?\d{2}-?\d{4}$/);
        if (!isSsn) {
            return null;
        }
        const str = control.value.replace('-', '');
        const sectionOne = str.substring(0, 3);
        const sectionTwo = str.substring(3, 5);
        if (!sectionOne.startsWith('9')) {
            return null;
        }
        if ((sectionTwo >= 70 && sectionTwo <= 88) ||
            (sectionTwo >= 90 && sectionTwo <= 92) ||
            (sectionTwo >= 94 && sectionTwo <= 99)) {
            return new ValidationMessagesError(itinValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}

const matchValueValidatorName = 'matchValue';
function matchValueValidator(value, text = 'Invalid Value', rules) {
    return function (control) {
        if (value instanceof Array) {
            return value.filter(x => x === control.value).length > 0
                ? null
                : new ValidationMessagesError(matchValueValidatorName, rules, text);
        }
        else if (control.value === value) {
            return null;
        }
        else {
            return new ValidationMessagesError(matchValueValidatorName, rules, text);
        }
    };
}

const maxLengthValidatorName = 'maxLength';
function maxLengthValidator(maxLength, text = 'Invalid Entry', rules) {
    return function (control) {
        const matchesLength = (typeof control.value === 'number' ||
            typeof control.value === 'string') &&
            control.value.toString().length <= maxLength;
        if (matchesLength) {
            return null;
        }
        else {
            return new ValidationMessagesError(maxLengthValidatorName, rules, text);
        }
    };
}

const minLengthValidatorName = 'minLength';
function minLengthValidator(minLength, text = 'Invalid Entry', rules) {
    return function (control) {
        const matchesLength = (typeof control.value === 'number' ||
            typeof control.value === 'string') &&
            control.value.toString().length >= minLength;
        if (matchesLength) {
            return null;
        }
        else {
            return new ValidationMessagesError(minLengthValidatorName, rules, text);
        }
    };
}

const noPoBoxValidatorName = 'pobox';
function noPoBoxValidator(text = 'PO boxes are not allowed.', rules) {
    return function (control) {
        if (Boolean(control.value) &&
            (containsPostBox(control.value) ||
                containsPostBoxFollowedByNumber(control.value))) {
            return new ValidationMessagesError(noPoBoxValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}
function containsPostBox(value) {
    return [
        'POST OFFICE',
        'POST OFFICEBOX',
        'POST OFFICEBX',
        'POSTOFFICEBOX',
        'POSTOFFICEBX',
        'POSTAL BOX',
        'PO BOX',
        'P.O. BOX',
        'P O BOX',
        'P. O. BOX',
        'POBOX',
        'POSTOFFICE',
        'POSTALBOX',
        'POSTALBX',
        'POBX',
        'POSTBOX',
        'POSTBX',
        'PBOX',
        'PBX',
    ].some((postBox) => value.match(new RegExp(`${postBox}`, 'i')) !== null);
}
function containsPostBoxFollowedByNumber(value) {
    return ['PO', 'BOX', 'BX'].some((postBox) => value.match(new RegExp(`^${postBox}\\s*\\d+`, 'i')) !== null);
}

const noRepeatedCharacterValidatorName = 'noRepeatedCharacterValidator';
function noRepeatedCharacterValidator(text = 'Cannot contain more than 2 repeating characters.', rules) {
    return function (control) {
        if (hasRepeatingCharacters(control.value)) {
            return new ValidationMessagesError(noRepeatedCharacterValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}
function hasRepeatingCharacters(text) {
    const regexIdentifyingCharactersRepeatedMoreThanThreeTimes = /(.)\1{2,}/;
    return regexIdentifyingCharactersRepeatedMoreThanThreeTimes.test(text);
}

const numericRangeValidatorName = 'numericRange';
function numericRangeValidator(minRange, maxRange, text = 'Invalid Range', rules) {
    return function (control) {
        if ([undefined, null, ''].includes(control.value)) {
            return null;
        }
        const num = Number(control.value) || Number(control.value.replace(/\D/g, ''));
        const isValidNumberAndWithinRange = num >= minRange && num <= maxRange;
        if (isValidNumberAndWithinRange) {
            return null;
        }
        return new ValidationMessagesError(numericRangeValidatorName, rules, text);
    };
}

const passwordComplexityValidatorName = 'passwordComplexityValidator';
const includeValidatorName = 'includeValidator';
function passwordComplexityValidator(text = '', rules) {
    return function (control) {
        if (isPasswordComplex(control.value)) {
            return null;
        }
        else {
            return new ValidationMessagesError(passwordComplexityValidatorName, rules, text);
        }
    };
}
function includeEmailValidator(text, email, rules = 'touched') {
    return function (control) {
        var _a;
        const errorModel = {
            [includeValidatorName]: { name: includeValidatorName, rules, text },
        };
        let emailValue = '';
        if (email) {
            emailValue = email;
        }
        else {
            const formInit = control.parent;
            if (!formInit) {
                return null;
            }
            const formGroup = formInit.parent;
            if (!formGroup) {
                return null;
            }
            emailValue = (_a = formGroup.get('emailGroup.email')) === null || _a === void 0 ? void 0 : _a.value;
        }
        const words = emailValue.split(new RegExp(['\\.', '-', '\\_', '\\@'].join('|'), 'g'));
        const included = words.some((x) => control.value.toLowerCase().includes(x.toLowerCase()));
        return included ? errorModel : null;
    };
}
function isPasswordComplex(password) {
    const numberOfChecksPassed = containsAnyUppercaseLetters(password) +
        containsAnyLowercaseLetters(password) +
        containsAnyNumbers(password) +
        containsAnySpecialCharacters(password);
    return numberOfChecksPassed === 4;
}
function containsAnyUppercaseLetters(value) {
    const regexIdentifyingNumbers = /[A-Z]/;
    return regexIdentifyingNumbers.test(value) ? 1 : 0;
}
function containsAnyLowercaseLetters(value) {
    const regexIdentifyingNumbers = /[a-z]/;
    return regexIdentifyingNumbers.test(value) ? 1 : 0;
}
function containsAnyNumbers(value) {
    const regexIdentifyingNumbers = /\d/;
    return regexIdentifyingNumbers.test(value) ? 1 : 0;
}
function containsAnySpecialCharacters(value) {
    const regexIdentifyingNumbers = /[$%^&*!@#]/;
    return regexIdentifyingNumbers.test(value) ? 1 : 0;
}
function containsMinCharacter(value) {
    return value ? (value.length < 8 ? 0 : 1) : 0;
}
function containsAnyEmailWord(email, password) {
    if (!email && !password) {
        return 0;
    }
    const items = email
        ? email.split(new RegExp(['\\.', '-', '\\_', '\\@'].join('|'), 'g'))
        : [' '];
    const valid = items.some((x) => password.toLowerCase().includes(x.toLowerCase()))
        ? 0
        : 1;
    return !password ? 0 : valid;
}

const requiredCheckboxValidatorName = 'required';
function requiredCheckboxValidator(text = '! Required field.', rules = [Rule.Touched]) {
    return function (control) {
        if (Validators.requiredTrue(control)) {
            return new ValidationMessagesError(requiredCheckboxValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}

const patternValidatorName = 'patternValidator';
function patternValidator(allowedPattern, text = '! The special characters you entered are invalid.', rules = [Rule.Touched]) {
    return function (control) {
        if (Validators.pattern(allowedPattern)(control)) {
            return new ValidationMessagesError(patternValidatorName, rules, text);
        }
        else {
            return null;
        }
    };
}

const requiredValidatorName = 'required';
function requiredValidator(text = '! Required field.', rules = [Rule.Touched]) {
    return function (control) {
        if (Validators.required(control)) {
            return new ValidationMessagesError(requiredValidatorName, rules, text);
        }
        return null;
    };
}

const routingNumberValidatorName = 'routingValidator';
function routingNumberValidator(text = 'Invalid Routing Number.', rules) {
    return function (control) {
        if (isValidRoutingNumber(control.value)) {
            return null;
        }
        else {
            return new ValidationMessagesError(routingNumberValidatorName, rules, text);
        }
    };
}
// https://en.wikipedia.org/wiki/ABA_routing_transit_number#Check_digit
function isValidRoutingNumber(routingNumber) {
    const validRoutingNumberFormat = /^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2])|(6[1-9])|(7[0-2]))([0-9]{7})$/;
    if (!routingNumber || !validRoutingNumberFormat.test(routingNumber)) {
        return false;
    }
    const [d1, d2, d3, d4, d5, d6, d7, d8, d9] = routingNumber
        .split('')
        .map(Number);
    return (3 * (d1 + d4 + d7) + 7 * (d2 + d5 + d8) + (d3 + d6 + d9)) % 10 === 0;
}

const atLeastOneValidatorName = 'atLeastOne';
function atLeastOneValidator(text = 'At least one entry is required', rules) {
    return function (control) {
        const group = control;
        let hasAtLeastOne = false;
        if (group && group.controls) {
            for (const controlField in group.controls) {
                if (group.controls.hasOwnProperty(controlField) &&
                    // group.controls[controlField].valid &&
                    group.controls[controlField].value) {
                    hasAtLeastOne = true;
                    break;
                }
            }
        }
        return hasAtLeastOne
            ? null
            : new ValidationMessagesError(atLeastOneValidatorName, rules, text);
    };
}

const ssnValidatorName = 'ssn';
function ssnValidator(text = 'Invalid Entry. Social Security Numbers are not accepted.', rules) {
    return function (control) {
        const isSsn = control.value && control.value.match(/\d/) && control.value.length === 9;
        if (isSsn) {
            return null;
        }
        return new ValidationMessagesError(ssnValidatorName, rules, text);
    };
}

class SafeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(ɵɵdirectiveInject(DomSanitizer)); };
SafeHtmlPipe.ɵpipe = ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeHtml',
            }]
    }], function () { return [{ type: DomSanitizer }]; }, null); })();

function ValidationMessagesComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "div", 1);
    ɵɵpipe(2, "safeHtml");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const error_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("@expand", undefined)("id", ctx_r0.getErrorId(error_r1.name))("innerHTML", ɵɵpipeBind1(2, 3, error_r1.text), ɵɵsanitizeHtml);
} }
function generateValidationErrorId(errorName, controlName) {
    const errorNameCapitalized = errorName.charAt(0).toUpperCase() + errorName.slice(1);
    return `${controlName}${errorNameCapitalized}ErrorText`;
}
class ValidationMessagesComponent {
    constructor(form, validationConfiguration) {
        this.form = form;
        this.validationConfiguration = validationConfiguration;
        if (!form) {
            throw Error('<ecl-validation-messages> component needs to be nested within a from group.');
        }
    }
    get errorStyleClass() {
        return this.controlClass
            ? JSON.parse('{ "' + this.controlClass + '": true }')
            : JSON.parse('{ "error-style": true }');
    }
    get control() {
        return this.form.control.get(this.controlName);
    }
    get controlNameWithoutGroup() {
        return this.controlName.split('.').pop();
    }
    get errors() {
        var _a;
        if (!((_a = this.control) === null || _a === void 0 ? void 0 : _a.errors)) {
            return [];
        }
        const errors = this.getRequiredErrorOrAllOtherErrors();
        if (this.showMultiErrors) {
            const visibleErrors = errors.filter((error) => this.shouldDisplay(error));
            return visibleErrors ? visibleErrors : [];
        }
        const visibleError = errors.find((error) => this.shouldDisplay(error));
        return visibleError ? [visibleError] : [];
    }
    getErrorId(errorName) {
        return errorName
            ? generateValidationErrorId(errorName, this.controlNameWithoutGroup)
            : '';
    }
    getRequiredErrorOrAllOtherErrors() {
        var _a, _b;
        if ((_b = (_a = this.control) === null || _a === void 0 ? void 0 : _a.errors) === null || _b === void 0 ? void 0 : _b.required) {
            return [this.control.errors.required];
        }
        else {
            return Object.values(this.control.errors);
        }
    }
    shouldDisplay(error) {
        return this.shouldShowValidationErrorsForControl(this.control, error);
    }
    shouldShowValidationErrorsForControl(control, error) {
        if (control.disabled) {
            return false;
        }
        const rules = error.rules || this.validationConfiguration.defaultRules;
        if (control instanceof FormGroup) {
            const formGroup = control;
            return Object.values(formGroup.controls).every((nestedControl) => this.shouldShowValidationErrorsForControl(nestedControl, error));
        }
        else {
            return rules.every((rule) => control[rule]);
        }
    }
}
ValidationMessagesComponent.ɵfac = function ValidationMessagesComponent_Factory(t) { return new (t || ValidationMessagesComponent)(ɵɵdirectiveInject(FormGroupDirective, 8), ɵɵdirectiveInject(ValidationConfiguration)); };
ValidationMessagesComponent.ɵcmp = ɵɵdefineComponent({ type: ValidationMessagesComponent, selectors: [["ecl-validation-messages"]], inputs: { controlName: "controlName", controlClass: "controlClass", showMultiErrors: "showMultiErrors" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["role", "alert", 1, "ecl-validation-message", 3, "id", "innerHTML"]], template: function ValidationMessagesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ValidationMessagesComponent_ng_container_0_Template, 3, 5, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngForOf", ctx.errors);
    } }, directives: [NgForOf], pipes: [SafeHtmlPipe], styles: [".ecl-validation-message[_ngcontent-%COMP%]{overflow:hidden}"], data: { animation: [
            trigger('expand', [
                transition(':enter', [
                    style({ height: '0px' }),
                    animate('150ms ease-out', style({ height: '*' })),
                ]),
                transition(':leave', [animate('150ms', style({ height: '0px' }))]),
            ]),
        ] } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ValidationMessagesComponent, [{
        type: Component,
        args: [{
                selector: 'ecl-validation-messages',
                templateUrl: './validation-messages.component.html',
                styleUrls: ['./validation-messages.component.scss'],
                animations: [
                    trigger('expand', [
                        transition(':enter', [
                            style({ height: '0px' }),
                            animate('150ms ease-out', style({ height: '*' })),
                        ]),
                        transition(':leave', [animate('150ms', style({ height: '0px' }))]),
                    ]),
                ],
            }]
    }], function () { return [{ type: FormGroupDirective, decorators: [{
                type: Optional
            }] }, { type: ValidationConfiguration }]; }, { controlName: [{
            type: Input
        }], controlClass: [{
            type: Input
        }], showMultiErrors: [{
            type: Input
        }] }); })();

function MockComponent(options) {
    var _a;
    const metadata = {
        selector: options.selector,
        template: options.template || '',
        inputs: options.inputs,
        outputs: options.outputs || [],
        exportAs: options.exportAs || '',
    };
    class Mock {
    }
    (_a = metadata.outputs) === null || _a === void 0 ? void 0 : _a.forEach((method) => {
        Mock.prototype[method] = new EventEmitter();
    });
    return Component(metadata)(Mock);
}

function mockDate(date) {
    jasmine.clock().mockDate(new Date(Date.parse(`${date}`)));
}

class TestErrorHandler {
    constructor() {
        this.isErrorExpected = false;
        this.wasErrorCalled = false;
    }
    handleError(error) {
        if (!this.isErrorExpected) {
            fail('Test threw error without the application or test handling that error.');
        }
        this.wasErrorCalled = true;
    }
    expectAnError() {
        this.isErrorExpected = true;
    }
    verifyErrorWasHandled() {
        expect(this.wasErrorCalled).toBeTruthy();
    }
}
TestErrorHandler.ɵfac = function TestErrorHandler_Factory(t) { return new (t || TestErrorHandler)(); };
TestErrorHandler.ɵprov = ɵɵdefineInjectable({ token: TestErrorHandler, factory: TestErrorHandler.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TestErrorHandler, [{
        type: Injectable
    }], null, null); })();
class TestErrorModule {
}
TestErrorModule.ɵmod = ɵɵdefineNgModule({ type: TestErrorModule });
TestErrorModule.ɵinj = ɵɵdefineInjector({ factory: function TestErrorModule_Factory(t) { return new (t || TestErrorModule)(); }, providers: [
        {
            provide: ErrorHandler,
            useClass: TestErrorHandler,
        },
    ] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TestErrorModule, [{
        type: NgModule,
        args: [{
                providers: [
                    {
                        provide: ErrorHandler,
                        useClass: TestErrorHandler,
                    },
                ],
            }]
    }], null, null); })();

class TestHtmlElement {
    constructor(selector) {
        this.selector = selector;
    }
    get name() {
        return `${this.constructor.name}(${this.selector})`;
    }
    get nativeElement() {
        return this.getNativeElement();
    }
    get textContent() {
        return this.nativeElement.textContent;
    }
    get innerHTML() {
        return this.nativeElement.innerHTML;
    }
    getNativeElement() {
        const element = document.querySelector(this.selector);
        if (!element) {
            fail(`${this.name} -- No element found for selector "${this.selector}"`);
        }
        return element;
    }
    click() {
        this.nativeElement.click();
        return this;
    }
    dispatchEvent(event) {
        this.nativeElement.dispatchEvent(new CustomEvent(event));
        return this;
    }
    focus() {
        return this.dispatchEvent('focus');
    }
    blur() {
        return this.dispatchEvent('blur');
    }
    mouseup() {
        return this.dispatchEvent('mouseup');
    }
    mouseenter() {
        return this.dispatchEvent('mouseenter');
    }
    mouseleave() {
        return this.dispatchEvent('mouseleave');
    }
    expectToBeHtmlElement() {
        return this.expectToBeElementOfType(HTMLElement);
    }
    expectToExist(errorMessage = `${this.name} -- Expected element to exist, but it did not.`) {
        expect(this.nativeElement !== null).toBe(true, errorMessage);
        return this;
    }
    expectNotToExist(errorMessage = `${this.name} -- Expected element not to exist, but it did`) {
        const element = document.querySelector(this.selector);
        expect(element === null).toBe(true, errorMessage);
        return this;
    }
    expectIsDisplayed(isDisplayed, errorMessage) {
        if (isDisplayed) {
            return this.expectToExist(errorMessage);
        }
        else {
            return this.expectNotToExist(errorMessage);
        }
    }
    expectText(expectedText) {
        const trimmedExpectedText = expectedText.replace(/\s+/g, ' ').trim();
        const trimmedActualText = this.textContent.replace(/\s+/g, ' ').trim();
        const errorMessage = `${this.name} -- Expected inner text to be ${trimmedExpectedText}, but got ${trimmedActualText}.`;
        expect(trimmedActualText).toEqual(trimmedExpectedText, errorMessage);
        return this;
    }
    expectToContainText(expectedText) {
        const trimmedExpectedText = expectedText.replace(/\s+/g, ' ').trim();
        const trimmedActualText = this.textContent.replace(/\s+/g, ' ').trim();
        const errorMessage = `${this.name} -- Expected inner text to contain "${expectedText}".`;
        expect(trimmedActualText).toContain(trimmedExpectedText, errorMessage);
        return this;
    }
    expectNotToContainText(expectedText) {
        const errorMessage = `${this.name} -- Expected inner text not to contain "${expectedText}".`;
        expect(this.textContent).not.toContain(expectedText, errorMessage);
        return this;
    }
    expectInnerHTML(expectedHTML) {
        const errorMessage = `${this.name} -- Expected inner HTML to be ${expectedHTML.trim()}, but got ${this.innerHTML.trim()}.`;
        expect(this.innerHTML.trim()).toEqual(expectedHTML.trim(), errorMessage);
        return this;
    }
    expectToHaveAttribute(attributeName) {
        const hasAttribute = this.nativeElement.hasAttribute(attributeName);
        const errorMessage = `${this.name} -- Expected element to have attribute '${attributeName}', but the attribute did not exist.`;
        expect(hasAttribute).toBe(true, errorMessage);
        return this;
    }
    expectNotToHaveAttribute(attributeName) {
        const hasAttribute = this.nativeElement.hasAttribute(attributeName);
        const errorMessage = `${this.name} -- Expected element not to have the attribute '${attributeName}', but the attribute did exist`;
        expect(hasAttribute).toBe(false, errorMessage);
        return this;
    }
    expectAttributeWithValue(attributeName, value) {
        const attributeValue = this.nativeElement.getAttribute(attributeName);
        const errorMessage = `${this.name} -- Expected the attribute ${attributeName} to have the value '${value}', but it is '${attributeValue}'.`;
        expect(attributeValue).toBe(value, errorMessage);
        return this;
    }
    expectToHaveClass(expectedClass, errorMessage = `Expected ${this.selector} to have css class '${expectedClass}' but it did not have that class.`) {
        const elementHasClass = this.nativeElement.classList.contains(expectedClass);
        expect(elementHasClass).toBe(true, errorMessage);
        return this;
    }
    expectNotToHaveClass(expectedClass, errorMessage = `Expected ${this.selector} not to have css class '${expectedClass}' but it has that class.`) {
        const elementHasClass = this.nativeElement.classList.contains(expectedClass);
        expect(elementHasClass).toBe(false, errorMessage);
        return this;
    }
    expectLinkToOpenInNewWindow() {
        this.expectAttributeWithValue('target', '_blank');
        return this;
    }
    expectLink(url) {
        this.expectAttributeWithValue('href', url);
        return this;
    }
    expectToBeElementOfType(expectedType) {
        const errorMessage = `${this.name} -- Expected the element to be of type <${expectedType.name}>, but it was not.`;
        expect(this.nativeElement instanceof expectedType).toBe(true, errorMessage);
        return this;
    }
}

class TestCheckboxElement extends TestHtmlElement {
    get nativeElement() {
        return this.getNativeElement();
    }
    get checked() {
        return this.nativeElement.checked;
    }
    check() {
        return this.setCheckedValue(true);
    }
    uncheck() {
        return this.setCheckedValue(false);
    }
    expectToBeCheckboxElement() {
        const errorMessage = `${this.name} -- Expected input element to be of type checkbox, but it was not.`;
        this.expectToBeElementOfType(HTMLInputElement);
        expect(this.nativeElement.type).toEqual('checkbox', errorMessage);
        return this;
    }
    expectToBeChecked() {
        const errorMessage = `${this.name} -- Expected checkbox to be checked, but it was not.`;
        expect(this.nativeElement.checked).toBeTruthy(errorMessage);
        return this;
    }
    expectNotToBeChecked() {
        const errorMessage = `${this.name} -- Expected checkbox to be unchecked, but it was not.`;
        expect(this.nativeElement.checked).toBeFalsy(errorMessage);
        return this;
    }
    expectToHaveValue(value) {
        const inputValue = this.nativeElement.value;
        const errorMessage = `${this.name} -- expected input to have value ${value}, but got ${inputValue}`;
        expect(inputValue).toEqual(value, errorMessage);
        return this;
    }
    setCheckedValue(value) {
        this.nativeElement.checked = value;
        this.nativeElement.dispatchEvent(new CustomEvent('change'));
        this.nativeElement.dispatchEvent(new CustomEvent('blur'));
        return this;
    }
    constructor(selector) {
        super(selector);
    }
}

class TestHtmlElements {
    constructor(selector) {
        this.selector = selector;
    }
    get name() {
        return `${this.constructor.name}(${this.selector})`;
    }
    get nativeElements() {
        return this.getNativeElements();
    }
    getNativeElements() {
        const elements = document.querySelectorAll(this.selector);
        if (!elements) {
            fail(`${this.name} -- No element found for selector "${this.selector}"`);
        }
        return Array.from(elements);
    }
    count() {
        return this.nativeElements.length;
    }
    expectToHaveCount(count, errorMessage = `${this.name} -- Expected to have ${count}, but has`) {
        const length = this.count();
        expect(length === count).toBe(true, ` ${errorMessage} ${length}`);
        return this;
    }
    expectToHaveClass(expectedClass, errorMessage = `Expected ${this.selector} to have css class '${expectedClass}' but elements do not have the class.`) {
        const elementsHaveClass = this.nativeElements.every((nativeElement) => nativeElement.classList.contains(expectedClass));
        expect(elementsHaveClass).toBe(true, errorMessage);
        return this;
    }
    expectNotToHaveClass(expectedClass, errorMessage = `Expected ${this.selector} not to have css class '${expectedClass}' but elements have that class.`) {
        const elementsNotHaveClass = this.nativeElements.every((nativeElement) => !nativeElement.classList.contains(expectedClass));
        expect(elementsNotHaveClass).toBe(true, errorMessage);
        return this;
    }
}

class TestInputElement extends TestHtmlElement {
    get nativeElement() {
        return this.getNativeElement();
    }
    get value() {
        return this.nativeElement.value;
    }
    setValue(value) {
        this.nativeElement.value = value;
        this.nativeElement.dispatchEvent(new CustomEvent('input'));
        this.nativeElement.dispatchEvent(new CustomEvent('change'));
        this.blur();
        return this;
    }
    simulateKeyStrokes(value) {
        const simulatedValue = value
            .split('')
            .reduce((actualValue, key) => {
            const validKey = this.nativeElement.dispatchEvent(new KeyboardEvent('keydown', {
                key,
            }));
            return validKey ? actualValue + key : actualValue;
        }, '');
        this.nativeElement.value = simulatedValue;
        this.dispatchEvent('keydown');
        this.dispatchEvent('keyup');
        return this.dispatchEvent('input');
    }
    input() {
        return this.dispatchEvent('input');
    }
    keydown(key) {
        return this.dispatchKeyBoardEvent('keydown', key);
    }
    keyup(key) {
        return this.dispatchKeyBoardEvent('keyup', key);
    }
    dispatchKeyBoardEvent(keyboardEvent, key, eventModifier = {}) {
        this.nativeElement.dispatchEvent(new KeyboardEvent(keyboardEvent, Object.assign({ key }, eventModifier)));
        return this;
    }
    selectText(start, end) {
        this.nativeElement.setSelectionRange(start, end);
        return this;
    }
    setCursorPosition(position) {
        this.nativeElement.setSelectionRange(position, position);
        return this;
    }
    expectCursorPosition(expectedPosition, expectationFailOutput) {
        expect(this.nativeElement.selectionStart).toBe(expectedPosition, expectationFailOutput);
        return this;
    }
    expectToBeInputElement() {
        return this.expectToBeElementOfType(HTMLInputElement);
    }
    expectFloatingLabel(expectedLabel) {
        const floatLabelElement = new TestHtmlElement(`${this.selector} ~ .rise-floating-label`);
        floatLabelElement.expectText(expectedLabel);
        return this;
    }
    expectToHaveValue(value) {
        const inputValue = this.nativeElement.value;
        const errorMessage = `${this.name} -- expected input to have value ${value}, but got ${inputValue}`;
        expect(inputValue).toEqual(value, errorMessage);
        return this;
    }
    expectNotToHaveValue(value) {
        const inputValue = this.nativeElement.value;
        const errorMessage = `${this.name} -- expected input not to have value ${value}, but got ${inputValue}.`;
        expect(inputValue).not.toEqual(value, errorMessage);
        return this;
    }
    expectValueToHaveLength(expectedLength) {
        const inputValueLength = this.nativeElement.value.length;
        const errorMessage = `${this.name} -- expected input value to have the length ${expectedLength}, but it was ${inputValueLength} characters long`;
        expect(inputValueLength).toEqual(expectedLength, errorMessage);
        return this;
    }
    constructor(selector) {
        super(selector);
    }
}

class TestSelectElement extends TestHtmlElement {
    get nativeElement() {
        return this.getNativeElement();
    }
    get value() {
        return this.nativeElement.value;
    }
    change() {
        return this.dispatchEvent('change');
    }
    selectOptionByIndex(index) {
        this.nativeElement.selectedIndex = index;
        this.change();
        this.blur();
        return this;
    }
    selectOptionByValue(value) {
        const options = Array.from(this.nativeElement.options);
        const optionIndex = options.findIndex((option) => option.value === value);
        return this.selectOptionByIndex(optionIndex);
    }
    selectOptionByText(text) {
        const options = Array.from(this.nativeElement.options);
        const optionIndex = options.findIndex((option) => option.text === text);
        return this.selectOptionByIndex(optionIndex);
    }
    expectToBeSelectElement() {
        return this.expectToBeElementOfType(HTMLSelectElement);
    }
    expectFloatingLabel(expectedLabel) {
        const floatLabelElement = new TestHtmlElement(`${this.selector} ~ .rise-floating-label`);
        floatLabelElement.expectText(expectedLabel);
        return this;
    }
    expectToHaveValue(value) {
        const selectValue = this.nativeElement.value;
        const errorMessage = `${this.name} -- Expected the select value to be ${value}, but it was ${selectValue}.`;
        expect(selectValue).toEqual(value, errorMessage);
        return this;
    }
    expectNotToHaveValue(value) {
        const selectValue = this.nativeElement.value;
        const errorMessage = `${this.name} -- Expected the select value not to be ${value}, but it was ${selectValue}.`;
        expect(selectValue).not.toEqual(value, errorMessage);
        return this;
    }
    expectSelectedText(expectedText) {
        const selectedOption = this.nativeElement[this.nativeElement.selectedIndex];
        const errorMessage = `${this.name} -- Expected the selected option text to be ${expectedText}, but got ${selectedOption.text}.`;
        expect(selectedOption.text).toEqual(expectedText, errorMessage);
        return this;
    }
    expectOptionLabels(expectedOptionTexts) {
        const actualOptionLabels = Array.from(this.nativeElement.options).map((option) => option.label);
        if (actualOptionLabels.length !== (expectedOptionTexts === null || expectedOptionTexts === void 0 ? void 0 : expectedOptionTexts.length)) {
            fail(`${this.name} -- Option elements (${actualOptionLabels}) do not have the expected options (${expectedOptionTexts})`);
        }
        else {
            actualOptionLabels.forEach((label, index) => {
                const expectedLabel = `${expectedOptionTexts[index]}`;
                const errorMessage = `${this.name} -- Expected the label ${expectedLabel}, but got ${label}`;
                expect(label).toEqual(expectedLabel, errorMessage);
            });
        }
        return this;
    }
    constructor(selector) {
        super(selector);
    }
}

class TestValidationMessageElement extends TestHtmlElement {
    constructor(formControlName, validatorName) {
        const selector = `#${generateValidationErrorId(validatorName, formControlName)}`;
        super(selector);
    }
}
class TestValidationMessagesElement extends TestHtmlElement {
    constructor(formControlName) {
        super(`[controlName="${formControlName}"]`);
        this.formControlName = formControlName;
    }
    getValidationMessageElement(validatorName) {
        const shortFormControlName = this.formControlName
            .toString()
            .split('.')
            .pop();
        return new TestValidationMessageElement(shortFormControlName, validatorName);
    }
}

class PipesModule {
}
PipesModule.ɵmod = ɵɵdefineNgModule({ type: PipesModule });
PipesModule.ɵinj = ɵɵdefineInjector({ factory: function PipesModule_Factory(t) { return new (t || PipesModule)(); }, providers: [CurrencyPipe, DecimalPipe, SafeHtmlPipe] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(PipesModule, { declarations: [SafeHtmlPipe], exports: [SafeHtmlPipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(PipesModule, [{
        type: NgModule,
        args: [{
                declarations: [SafeHtmlPipe],
                providers: [CurrencyPipe, DecimalPipe, SafeHtmlPipe],
                exports: [SafeHtmlPipe],
            }]
    }], null, null); })();

class EclValidationModule {
}
EclValidationModule.ɵmod = ɵɵdefineNgModule({ type: EclValidationModule });
EclValidationModule.ɵinj = ɵɵdefineInjector({ factory: function EclValidationModule_Factory(t) { return new (t || EclValidationModule)(); }, providers: [ValidationConfiguration], imports: [[CommonModule, ReactiveFormsModule, PipesModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(EclValidationModule, { declarations: [ValidationMessagesComponent, ValidationInputClassDirective], imports: [CommonModule, ReactiveFormsModule, PipesModule], exports: [ValidationMessagesComponent, ValidationInputClassDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(EclValidationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ReactiveFormsModule, PipesModule],
                declarations: [ValidationMessagesComponent, ValidationInputClassDirective],
                exports: [ValidationMessagesComponent, ValidationInputClassDirective],
                providers: [ValidationConfiguration],
            }]
    }], null, null); })();

const deepMerge = deepMerge_;
class DynamicModel {
    constructor() {
        this.updatedSubject = new BehaviorSubject({});
        this.isDestroyed = new Subject();
    }
    get value() {
        return this.updatedSubject.value;
    }
    get valueChangesUntilDestroyed() {
        return this.updatedSubject.pipe(takeUntil(this.isDestroyed));
    }
    mergeValue(value) {
        const newValue = deepMerge(this.value, value);
        this.updatedSubject.next(newValue);
    }
    ngOnDestroy() {
        this.isDestroyed.next();
        this.isDestroyed.complete();
    }
}
DynamicModel.ɵfac = function DynamicModel_Factory(t) { return new (t || DynamicModel)(); };
DynamicModel.ɵprov = ɵɵdefineInjectable({ token: DynamicModel, factory: DynamicModel.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DynamicModel, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PageFormsTracker {
    constructor(configuration, dynamicModel) {
        this.configuration = configuration;
        this.dynamicModel = dynamicModel;
        this.controls = [];
    }
    get isValid() {
        return this.controls
            .filter((control) => control.enabled)
            .every((control) => control.valid);
    }
    track(form) {
        this.controls.push(form);
        this.mergeValuesWhenFormChanges(form);
    }
    showValidationErrors() {
        this.controls.forEach((control) => this.showValidationErrorsForControl(control));
    }
    getFormValue() {
        this.showValidationErrors();
        return this.isValid ? this.dynamicModel.value : undefined;
    }
    showValidationErrorsForControl(control) {
        if (control.disabled) {
            return;
        }
        if (!this.configuration) {
            this.configuration = {
                defaultRules: [Rule.Touched, Rule.Dirty],
            };
        }
        if (this.configuration.defaultRules.includes(Rule.Dirty)) {
            control.markAsDirty();
        }
        if (this.configuration.defaultRules.includes(Rule.Touched)) {
            control.markAsTouched();
        }
        if (control instanceof FormGroup) {
            Object.values(control.controls).forEach((nestedControl) => {
                this.showValidationErrorsForControl(nestedControl);
            });
        }
    }
    mergeValuesWhenFormChanges(form) {
        form.valueChangesUntilDestroyed.subscribe(() => this.mergeDynamicForm(form), null, () => this.onFormDestroy(form));
    }
    onFormDestroy(form) {
        form.disable();
        form.reset();
        this.mergeDynamicForm(form);
        this.removeDisabledForms();
    }
    mergeDynamicForm(form) {
        const value = form.mapFormValuesToApiModel();
        if (!this.dynamicModel) {
            this.dynamicModel = new DynamicModel();
        }
        this.dynamicModel.mergeValue(value);
    }
    removeDisabledForms() {
        this.controls = this.controls.filter((control) => !control.disabled);
    }
}
PageFormsTracker.ɵfac = function PageFormsTracker_Factory(t) { return new (t || PageFormsTracker)(ɵɵinject(ValidationConfiguration), ɵɵinject(DynamicModel)); };
PageFormsTracker.ɵprov = ɵɵdefineInjectable({ token: PageFormsTracker, factory: PageFormsTracker.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PageFormsTracker, [{
        type: Injectable
    }], function () { return [{ type: ValidationConfiguration }, { type: DynamicModel }]; }, null); })();

class TrackedForm extends FormGroup {
    constructor() {
        super(...arguments);
        this.isDestroyed = new Subject();
        // tslint:disable-next-line:member-ordering
        this.valueChangesUntilDestroyed = this.valueChanges.pipe(takeUntil(this.isDestroyed));
    }
    ngOnDestroy() {
        this.isDestroyed.next();
        this.isDestroyed.complete();
    }
}
TrackedForm.ɵfac = function TrackedForm_Factory(t) { return ɵTrackedForm_BaseFactory(t || TrackedForm); };
TrackedForm.ɵdir = ɵɵdefineDirective({ type: TrackedForm, features: [ɵɵInheritDefinitionFeature] });
const ɵTrackedForm_BaseFactory = ɵɵgetInheritedFactory(TrackedForm);
/*@__PURE__*/ (function () { ɵsetClassMetadata(TrackedForm, [{
        type: Directive
    }], null, null); })();

class FocusOnLoadDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngAfterViewInit() {
        this.elementRef.nativeElement.focus();
    }
}
FocusOnLoadDirective.ɵfac = function FocusOnLoadDirective_Factory(t) { return new (t || FocusOnLoadDirective)(ɵɵdirectiveInject(ElementRef)); };
FocusOnLoadDirective.ɵdir = ɵɵdefineDirective({ type: FocusOnLoadDirective, selectors: [["", "eclFocusOnLoad", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FocusOnLoadDirective, [{
        type: Directive,
        args: [{
                selector: '[eclFocusOnLoad]',
            }]
    }], function () { return [{ type: ElementRef }]; }, null); })();

class PasswordTypeOnBlurDirective {
    convertToInputTypePassword(input) {
        input.type = 'password';
    }
    convertToInputTypeText(input) {
        input.type = 'text';
    }
}
PasswordTypeOnBlurDirective.ɵfac = function PasswordTypeOnBlurDirective_Factory(t) { return new (t || PasswordTypeOnBlurDirective)(); };
PasswordTypeOnBlurDirective.ɵdir = ɵɵdefineDirective({ type: PasswordTypeOnBlurDirective, selectors: [["", "eclPasswordTypeOnBlur", ""]], hostBindings: function PasswordTypeOnBlurDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function PasswordTypeOnBlurDirective_blur_HostBindingHandler($event) { return ctx.convertToInputTypePassword($event.target); })("focus", function PasswordTypeOnBlurDirective_focus_HostBindingHandler($event) { return ctx.convertToInputTypeText($event.target); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PasswordTypeOnBlurDirective, [{
        type: Directive,
        args: [{
                selector: '[eclPasswordTypeOnBlur]',
            }]
    }], null, { convertToInputTypePassword: [{
            type: HostListener,
            args: ['blur', ['$event.target']]
        }], convertToInputTypeText: [{
            type: HostListener,
            args: ['focus', ['$event.target']]
        }] }); })();

class RestrictInputDirective {
    constructor() {
        this.specialKeys = [
            'Enter',
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'Home',
            'End',
            'PageUp',
            'PageDown',
        ];
    }
    onKeydown(event) {
        const pattern = new RegExp(this.eclRestrictInput);
        const key = event.key;
        return this.specialKeys.includes(key) || pattern.test(key);
    }
}
RestrictInputDirective.ɵfac = function RestrictInputDirective_Factory(t) { return new (t || RestrictInputDirective)(); };
RestrictInputDirective.ɵdir = ɵɵdefineDirective({ type: RestrictInputDirective, selectors: [["", "eclRestrictInput", ""]], hostBindings: function RestrictInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("keydown", function RestrictInputDirective_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); });
    } }, inputs: { eclRestrictInput: "eclRestrictInput" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RestrictInputDirective, [{
        type: Directive,
        args: [{
                selector: '[eclRestrictInput]',
            }]
    }], null, { eclRestrictInput: [{
            type: Input,
            args: ['eclRestrictInput']
        }], onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }] }); })();

class MaskedElementCursor {
    constructor(nativeElement, maskOptions) {
        this.nativeElement = nativeElement;
        this.maskOptions = maskOptions;
    }
    get currentCursorPosition() {
        return this.nativeElement.selectionStart;
    }
    get isCursorAfterNextPlaceholder() {
        var _a, _b;
        if (this.locationOfFirstPlaceholder === -1) {
            return false;
        }
        return (((_a = this.nativeElement) === null || _a === void 0 ? void 0 : _a.selectionStart) > this.locationOfFirstPlaceholder ||
            ((_b = this.nativeElement) === null || _b === void 0 ? void 0 : _b.selectionEnd) > this.locationOfFirstPlaceholder);
    }
    get locationOfFirstPlaceholder() {
        return this.nativeElement.value
            .split('')
            .findIndex((character) => character === this.maskOptions.placeholderChar);
    }
    get hasMultipleCharactersSelected() {
        return (this.nativeElement.selectionStart !== this.nativeElement.selectionEnd);
    }
    moveAfterFirstEditableCharacter() {
        if (this.isCursorAfterNextPlaceholder) {
            this.moveCursorToFirstPlaceholder();
        }
    }
    moveBeforeNextDeletableCharacterAfterDelete() {
        if (this.isCursorBeforeMaskCharacter()) {
            this.moveCursorToTheNextEditableCharacter();
        }
    }
    moveBeforeNextDeletableCharacterBeforeDelete() {
        if (this.hasMultipleCharactersSelected) {
            return;
        }
        if (this.isCursorBeforeMaskCharacter()) {
            this.moveCursorToTheNextEditableCharacter();
        }
    }
    isCursorBeforeMaskCharacter() {
        return (this.maskOptions.mask.length > this.currentCursorPosition &&
            !(this.maskOptions.mask[this.currentCursorPosition] instanceof RegExp));
    }
    moveCursorToFirstPlaceholder() {
        this.nativeElement.setSelectionRange(this.locationOfFirstPlaceholder, this.locationOfFirstPlaceholder);
    }
    moveCursorToTheNextEditableCharacter() {
        const nextEditableCharacter = this.maskOptions.mask
            .slice(this.currentCursorPosition)
            .findIndex((character) => character instanceof RegExp) + this.currentCursorPosition;
        this.nativeElement.setSelectionRange(nextEditableCharacter, nextEditableCharacter);
    }
}
class TextMaskDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.defaultOptions = {
            showMask: true,
            mask: [],
            guide: true,
            placeholderChar: '_',
            pipe: undefined,
            keepCharPositions: false,
        };
    }
    get inputValue() {
        return this.inputElement.value;
    }
    get maskOptions() {
        return Object.assign(this.defaultOptions, this.eclTextMask);
    }
    get inputHasValue() {
        return Boolean(this.inputValue);
    }
    get mask() {
        return this.maskOptions.mask
            .map((character) => {
            if (character instanceof RegExp) {
                return this.maskOptions.placeholderChar;
            }
            else {
                return character;
            }
        })
            .join('');
    }
    get inputElement() {
        return this.elementRef.nativeElement;
    }
    ngOnInit() {
        this.textMask = createTextMaskInputElement(Object.assign({ inputElement: this.inputElement }, this.maskOptions));
        this.cursor = new MaskedElementCursor(this.inputElement, this.maskOptions);
    }
    writeValue(value) {
        if (value === '') {
            this.setInputValue('');
        }
        else {
            this.textMask.update(value);
        }
    }
    registerOnChange(setFormControlValue) {
        this.setFormControlValue = setFormControlValue;
    }
    registerOnTouched(markFormControlAsTouched) {
        this.markFormControlAsTouched = markFormControlAsTouched;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.renderer.setAttribute(this.inputElement, 'disabled', 'disabled');
        }
        else {
            this.renderer.removeAttribute(this.inputElement, 'disabled');
        }
    }
    maskValue(value) {
        this.textMask.update(value);
        this.updateFormControlValue();
    }
    clearValueWhenValueIsOnlyMask() {
        if (this.inputValue === this.mask) {
            this.setInputValue('');
        }
        this.markFormControlAsTouched();
    }
    showMaskWhenFocusedWithoutValue() {
        if (this.inputHasValue) {
            return;
        }
        this.setInputValue(this.mask);
        this.cursor.moveAfterFirstEditableCharacter();
    }
    mouseup() {
        this.cursor.moveAfterFirstEditableCharacter();
    }
    arrowRight() {
        this.cursor.moveAfterFirstEditableCharacter();
    }
    keyupDelete() {
        this.cursor.moveBeforeNextDeletableCharacterAfterDelete();
    }
    keydownDelete() {
        this.cursor.moveBeforeNextDeletableCharacterBeforeDelete();
    }
    updateFormControlValue() {
        if (!this.setFormControlValue) {
            return;
        }
        if (this.inputValue === this.mask) {
            this.setFormControlValue('');
        }
        else {
            this.setFormControlValue(this.inputValue);
        }
    }
    setInputValue(value) {
        this.inputElement.value = value;
    }
}
TextMaskDirective.ɵfac = function TextMaskDirective_Factory(t) { return new (t || TextMaskDirective)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Renderer2)); };
TextMaskDirective.ɵdir = ɵɵdefineDirective({ type: TextMaskDirective, selectors: [["", "eclTextMask", ""]], hostBindings: function TextMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("input", function TextMaskDirective_input_HostBindingHandler($event) { return ctx.maskValue($event.target.value); })("blur", function TextMaskDirective_blur_HostBindingHandler() { return ctx.clearValueWhenValueIsOnlyMask(); })("focus", function TextMaskDirective_focus_HostBindingHandler() { return ctx.showMaskWhenFocusedWithoutValue(); })("mouseup", function TextMaskDirective_mouseup_HostBindingHandler() { return ctx.mouseup(); })("keyup.end", function TextMaskDirective_keyup_end_HostBindingHandler() { return ctx.arrowRight(); })("keyup.control.end", function TextMaskDirective_keyup_control_end_HostBindingHandler() { return ctx.arrowRight(); })("keyup.arrowdown", function TextMaskDirective_keyup_arrowdown_HostBindingHandler() { return ctx.arrowRight(); })("keyup.control.arrowdown", function TextMaskDirective_keyup_control_arrowdown_HostBindingHandler() { return ctx.arrowRight(); })("keyup.arrowright", function TextMaskDirective_keyup_arrowright_HostBindingHandler() { return ctx.arrowRight(); })("keyup.control.arrowright", function TextMaskDirective_keyup_control_arrowright_HostBindingHandler() { return ctx.arrowRight(); })("keyup.delete", function TextMaskDirective_keyup_delete_HostBindingHandler() { return ctx.keyupDelete(); })("keydown.delete", function TextMaskDirective_keydown_delete_HostBindingHandler() { return ctx.keydownDelete(); });
    } }, inputs: { eclTextMask: "eclTextMask" }, exportAs: ["textMask"], features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: TextMaskDirective,
                multi: true,
            },
        ])] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TextMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[eclTextMask]',
                exportAs: 'textMask',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: TextMaskDirective,
                        multi: true,
                    },
                ],
            }]
    }], function () { return [{ type: ElementRef }, { type: Renderer2 }]; }, { eclTextMask: [{
            type: Input
        }], maskValue: [{
            type: HostListener,
            args: ['input', ['$event.target.value']]
        }], clearValueWhenValueIsOnlyMask: [{
            type: HostListener,
            args: ['blur']
        }], showMaskWhenFocusedWithoutValue: [{
            type: HostListener,
            args: ['focus']
        }], mouseup: [{
            type: HostListener,
            args: ['mouseup']
        }], arrowRight: [{
            type: HostListener,
            args: ['keyup.end']
        }, {
            type: HostListener,
            args: ['keyup.control.end']
        }, {
            type: HostListener,
            args: ['keyup.arrowdown']
        }, {
            type: HostListener,
            args: ['keyup.control.arrowdown']
        }, {
            type: HostListener,
            args: ['keyup.arrowright']
        }, {
            type: HostListener,
            args: ['keyup.control.arrowright']
        }], keyupDelete: [{
            type: HostListener,
            args: ['keyup.delete']
        }], keydownDelete: [{
            type: HostListener,
            args: ['keydown.delete']
        }] }); })();

class DateTextMaskDirective extends TextMaskDirective {
    constructor() {
        super(...arguments);
        this.eclTextMask = {
            mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
        };
    }
}
DateTextMaskDirective.ɵfac = function DateTextMaskDirective_Factory(t) { return ɵDateTextMaskDirective_BaseFactory(t || DateTextMaskDirective); };
DateTextMaskDirective.ɵdir = ɵɵdefineDirective({ type: DateTextMaskDirective, selectors: [["", "eclDateTextMask", ""]], features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: DateTextMaskDirective,
                multi: true,
            },
        ]), ɵɵInheritDefinitionFeature] });
const ɵDateTextMaskDirective_BaseFactory = ɵɵgetInheritedFactory(DateTextMaskDirective);
/*@__PURE__*/ (function () { ɵsetClassMetadata(DateTextMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[eclDateTextMask]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DateTextMaskDirective,
                        multi: true,
                    },
                ],
            }]
    }], null, null); })();

class PhoneNumberTextMaskDirective extends TextMaskDirective {
    constructor() {
        super(...arguments);
        this.eclTextMask = {
            mask: [
                '(',
                /[1-9]/,
                /\d/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
            ],
        };
    }
}
PhoneNumberTextMaskDirective.ɵfac = function PhoneNumberTextMaskDirective_Factory(t) { return ɵPhoneNumberTextMaskDirective_BaseFactory(t || PhoneNumberTextMaskDirective); };
PhoneNumberTextMaskDirective.ɵdir = ɵɵdefineDirective({ type: PhoneNumberTextMaskDirective, selectors: [["", "eclPhoneNumberTextMask", ""]], features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: PhoneNumberTextMaskDirective,
                multi: true,
            },
        ]), ɵɵInheritDefinitionFeature] });
const ɵPhoneNumberTextMaskDirective_BaseFactory = ɵɵgetInheritedFactory(PhoneNumberTextMaskDirective);
/*@__PURE__*/ (function () { ɵsetClassMetadata(PhoneNumberTextMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[eclPhoneNumberTextMask]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: PhoneNumberTextMaskDirective,
                        multi: true,
                    },
                ],
            }]
    }], null, null); })();

class SocialSecurityNumberTextMaskDirective extends TextMaskDirective {
    constructor() {
        super(...arguments);
        this.eclTextMask = {
            mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
        };
    }
}
SocialSecurityNumberTextMaskDirective.ɵfac = function SocialSecurityNumberTextMaskDirective_Factory(t) { return ɵSocialSecurityNumberTextMaskDirective_BaseFactory(t || SocialSecurityNumberTextMaskDirective); };
SocialSecurityNumberTextMaskDirective.ɵdir = ɵɵdefineDirective({ type: SocialSecurityNumberTextMaskDirective, selectors: [["", "eclSocialSecurityNumberTextMask", ""]], features: [ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: SocialSecurityNumberTextMaskDirective,
                multi: true,
            },
        ]), ɵɵInheritDefinitionFeature] });
const ɵSocialSecurityNumberTextMaskDirective_BaseFactory = ɵɵgetInheritedFactory(SocialSecurityNumberTextMaskDirective);
/*@__PURE__*/ (function () { ɵsetClassMetadata(SocialSecurityNumberTextMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[eclSocialSecurityNumberTextMask]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: SocialSecurityNumberTextMaskDirective,
                        multi: true,
                    },
                ],
            }]
    }], null, null); })();

class TrimInputDirective {
    trimInputValueOnBlur(elementToTrim) {
        if (!elementToTrim.value) {
            return;
        }
        const trimmedValue = elementToTrim.value.trim();
        // https://github.com/anein/angular2-trim-directive/issues/9
        // fix issue where email inputs don't trim on 2nd blur
        elementToTrim.value = '';
        elementToTrim.value = trimmedValue;
        // let DefaultValueAccessor know to update form control with native input
        elementToTrim.dispatchEvent(new CustomEvent('input'));
    }
}
TrimInputDirective.ɵfac = function TrimInputDirective_Factory(t) { return new (t || TrimInputDirective)(); };
TrimInputDirective.ɵdir = ɵɵdefineDirective({ type: TrimInputDirective, selectors: [["input", "type", "text", 3, "noTrimOnBlur", ""], ["input", "type", "email", 3, "noTrimOnBlur", ""]], hostBindings: function TrimInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("blur", function TrimInputDirective_blur_HostBindingHandler($event) { return ctx.trimInputValueOnBlur($event.target); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TrimInputDirective, [{
        type: Directive,
        args: [{
                selector: 
                // tslint:disable-next-line:directive-selector
                'input[type="text"]:not([noTrimOnBlur]), input[type="email"]:not([noTrimOnBlur])',
            }]
    }], null, { trimInputValueOnBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target']]
        }] }); })();

const EF_DIRECTIVES = [
    FocusOnLoadDirective,
    RestrictInputDirective,
    TextMaskDirective,
    PasswordTypeOnBlurDirective,
    TrimInputDirective,
    PhoneNumberTextMaskDirective,
    DateTextMaskDirective,
    SocialSecurityNumberTextMaskDirective,
];

class DynamicFormsModule {
}
DynamicFormsModule.ɵmod = ɵɵdefineNgModule({ type: DynamicFormsModule });
DynamicFormsModule.ɵinj = ɵɵdefineInjector({ factory: function DynamicFormsModule_Factory(t) { return new (t || DynamicFormsModule)(); }, providers: [DynamicModel], imports: [[CommonModule, ReactiveFormsModule, PipesModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DynamicFormsModule, { declarations: [FocusOnLoadDirective, RestrictInputDirective, TextMaskDirective, PasswordTypeOnBlurDirective, TrimInputDirective, PhoneNumberTextMaskDirective, DateTextMaskDirective, SocialSecurityNumberTextMaskDirective], imports: [CommonModule, ReactiveFormsModule, PipesModule], exports: [FocusOnLoadDirective, RestrictInputDirective, TextMaskDirective, PasswordTypeOnBlurDirective, TrimInputDirective, PhoneNumberTextMaskDirective, DateTextMaskDirective, SocialSecurityNumberTextMaskDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DynamicFormsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ReactiveFormsModule, PipesModule],
                declarations: [...EF_DIRECTIVES],
                exports: [...EF_DIRECTIVES],
                providers: [DynamicModel],
            }]
    }], null, null); })();

class EclFormsModule {
}
EclFormsModule.ɵmod = ɵɵdefineNgModule({ type: EclFormsModule });
EclFormsModule.ɵinj = ɵɵdefineInjector({ factory: function EclFormsModule_Factory(t) { return new (t || EclFormsModule)(); }, imports: [[CommonModule, DynamicFormsModule, EclValidationModule],
        DynamicFormsModule, EclValidationModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(EclFormsModule, { imports: [CommonModule, DynamicFormsModule, EclValidationModule], exports: [DynamicFormsModule, EclValidationModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(EclFormsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, DynamicFormsModule, EclValidationModule],
                exports: [DynamicFormsModule, EclValidationModule],
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DateTextMaskDirective, DynamicFormsModule, DynamicModel, EF_DIRECTIVES, EclFormsModule, EclValidationModule, FocusOnLoadDirective, PageFormsTracker, PasswordTypeOnBlurDirective, PhoneNumberTextMaskDirective, PipesModule, RestrictInputDirective, Rule, SafeHtmlPipe, SocialSecurityNumberTextMaskDirective, TestValidationMessagesElement, TextMaskDirective, TrackedForm, TrimInputDirective, ValidationConfiguration, ValidationError, ValidationInputClassDirective, ValidationMessagesComponent, ValidationMessagesError, atLeastOneValidator, atLeastOneValidatorName, containsAnyEmailWord, containsAnyLowercaseLetters, containsAnyNumbers, containsAnySpecialCharacters, containsAnyUppercaseLetters, containsMinCharacter, dateRangeValidator, dateRangeValidatorName, dateValidator, dateValidatorName, emailRegex, emailValidator, emailValidatorName, fixedLengthValidator, fixedLengthValidatorName, generateValidationErrorId, includeEmailValidator, includeValidatorName, inputMatchValidator, inputMatchValidatorName, inputNotMatchValidator, inputNotMatchValidatorName, inputsMatchValidator, inputsMatchValidatorName, isPasswordComplex, isValidRoutingNumber, itinValidator, itinValidatorName, matchValueValidator, matchValueValidatorName, maxLengthValidator, maxLengthValidatorName, minLengthValidator, minLengthValidatorName, noPoBoxValidator, noPoBoxValidatorName, noRepeatedCharacterValidator, noRepeatedCharacterValidatorName, numericRangeValidator, numericRangeValidatorName, passwordComplexityValidator, passwordComplexityValidatorName, patternValidator, patternValidatorName, requiredCheckboxValidator, requiredCheckboxValidatorName, requiredValidator, requiredValidatorName, routingNumberValidator, routingNumberValidatorName, ssnValidator, ssnValidatorName };
//# sourceMappingURL=elevate-forms.js.map
